import { isNil, map, pick } from 'lodash'

import { PROJECT_SOURCES } from '../../../common/constants'
import { isDbId } from '../../../common/utils'

const propsForSaving = [
  'id',
  'parentId',
  'term',
  'type',
  'subtype',
  'source',
  'languageId',
]

const transformToUpdateTransferedKeywordsArgs = (idToTransferTo, data) =>
  map(data, item => ({
    ...pick(item, propsForSaving),
    ingredientId: idToTransferTo,
    source:
      isDbId(item.id) && !isNil(item.source)
        ? item.source
        : PROJECT_SOURCES.METADATA,
    isName: isNil(item.isName) ? false : item.isName,
  }))

export default transformToUpdateTransferedKeywordsArgs
